import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { BRAND } from "../lib/brand";
import { forgotPassword, formatApiErrorDetail } from "../lib/auth";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Gagal mengirim. Coba lagi.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-5" data-testid="forgot-password-page">
      <div className="max-w-md w-full bg-white rounded-3xl border border-soft p-8 soft-shadow">
        <div className="flex items-center gap-2 mb-6">
          <img src={BRAND.logoIcon} alt="AsiaCommerce" className="h-10 w-10 object-contain" />
          <div>
            <div className="font-display font-extrabold text-lg text-ink">Lupa Password</div>
            <div className="text-xs text-ink-muted">AsiaCommerce Hub</div>
          </div>
        </div>

        {submitted ? (
          <div className="text-center py-6" data-testid="forgot-success">
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <MailCheck className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="font-display font-bold text-xl text-ink">Cek email Anda</h2>
            <p className="mt-3 text-sm text-ink-muted">
              Jika email <strong>{email}</strong> terdaftar sebagai admin, kami sudah kirim link reset password yang berlaku 15 menit.
            </p>
            <Link to="/admin" className="inline-block mt-6">
              <Button variant="outline" className="rounded-full border-soft" data-testid="forgot-back-btn">
                <ArrowLeft className="w-4 h-4 mr-2" /> Kembali ke login
              </Button>
            </Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <p className="text-sm text-ink-muted">
              Masukkan email admin Anda. Kami akan kirim link untuk reset password (berlaku 15 menit).
            </p>
            <div>
              <Label className="text-sm font-semibold text-ink">Email admin</Label>
              <Input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="forgot-email"
                className="h-12 rounded-xl border-soft mt-1.5"
                placeholder="admin@asiacommerce.net"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-full bg-brand-red hover:bg-[#A60D25] text-white font-semibold" data-testid="forgot-submit-btn">
              {loading ? "Mengirim…" : "Kirim Link Reset"}
            </Button>
            <Link to="/admin" className="block text-center text-xs text-ink-muted hover:text-brand-red">← Kembali ke login</Link>
          </form>
        )}
      </div>
    </div>
  );
}
